var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "44",
        "height": "44",
        "viewBox": "0 0 88 88",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('defs', [_c('linearGradient', {
      attrs: {
        "x1": "50%",
        "y1": "-29.875%",
        "x2": "50%",
        "y2": "100%",
        "id": "a"
      }
    }, [_c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColorTop)",
        "offset": "0%"
      }
    }), _c('stop', {
      attrs: {
        "stop-color": "var(--homeIconColotBot)",
        "offset": "100%"
      }
    })])]), _c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('circle', {
      attrs: {
        "fill": "url(#a)",
        "cx": "44",
        "cy": "44",
        "r": "44"
      }
    }), _c('path', {
      attrs: {
        "d": "M28 28h32v32H28z"
      }
    }), _c('g', {
      attrs: {
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M48.57 30.025v4.328a2.4 2.4 0 00.737 1.744c.467.467 1.1.728 1.76.728h4.352v17.928a2.48 2.48 0 01-2.488 2.472H35.507a2.504 2.504 0 01-1.76-.728 2.448 2.448 0 01-.728-1.744V32.497a2.48 2.48 0 012.488-2.472H48.57zM45.42 48.281l.984-4.272a.408.408 0 00-.184-.44.376.376 0 00-.464.064l-5.424 5.6a.408.408 0 00-.08.44.368.368 0 00.352.24h2.4l-.968 4.28a.4.4 0 00.184.44.368.368 0 00.456-.064l5.416-5.6a.392.392 0 00.08-.432.376.376 0 00-.352-.248l-2.4-.008zm-7.736-13.928a.928.928 0 100 1.856h6.848a.928.928 0 100-1.856h-6.848zm0 4.944a.928.928 0 100 1.856h13.072a.928.928 0 000-1.856H37.683z",
        "fill": "#FFF"
      }
    }), _c('path', {
      attrs: {
        "d": "M48.57 30.025l6.849 6.848h-4.352a2.512 2.512 0 01-2.496-2.496v-4.352z",
        "fill": "#F2BEBE"
      }
    })])])]));
  }
};